import { render, staticRenderFns } from "./FeeStudentsComponent.vue?vue&type=template&id=47ff831d&"
import script from "./FeeStudentsComponent.vue?vue&type=script&lang=js&"
export * from "./FeeStudentsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports